<template>
<div class="chapter">
<div class="inner_page">
<p class="cimage"><img alt="image" src="images/ch.jpg"/></p>
<h2 class="fm-title"><span class="bold">Acknowledgments</span></h2>
<p class="noindent"><span class="dropcap">I</span> wish to thank all the people who have attended my classes, seminars, and masterminds. Your kind words, encouragement, and 5-star reviews have made it easy for me to keep going, even when I am tired or unmotivated. You all are my inspiration.</p>
<p class="indent">I would like to also recognize the people who are or have worked for Investor Schooling. Phil Falcone my partner, Jamie Lenegan our senior Student Liaison, Paul Marturano our marketing director, Ken McArthur our assistant producer, Pedro Quinones our show and studio producer, and all the others who helped along the way, such as Fred Posimo, Evan Zaremba, Carrie Smith, Stone Falcone, and so many more.</p>
<p class="indent">Mostly, I would like to recognize my wife, Linda Steinhouse, who has to put up with my crap at home and at work!</p>
<p class="indent">Thanks to all of you!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm03.vue?fe73545e